import {
    Input,
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue
} from "@solomon-labs/design/components/ui";
import type { ReactElement } from "react";

import {
    isLegalEntityTypeSelection,
    LEGAL_ENTITY_TYPE_OPTIONS,
    type LegalEntityTypeDraft,
    legalEntityTypeLabel
} from "@/data/legalEntityTypes";

interface LegalEntityTypeSelectProps {
    value: LegalEntityTypeDraft;
    onChange: (next: LegalEntityTypeDraft) => void;
    id?: string;
    error?: boolean;
    errorId?: string;
}

export function LegalEntityTypeSelect({
    value,
    onChange,
    id,
    error = false,
    errorId
}: LegalEntityTypeSelectProps): ReactElement {
    const otherSelected = value.selection === "other";

    return (
        <div className="flex flex-col gap-3">
            <Select
                value={value.selection ?? ""}
                onValueChange={(next) => {
                    if (!isLegalEntityTypeSelection(next)) return;
                    onChange({ ...value, selection: next });
                }}
            >
                <SelectTrigger
                    id={id}
                    aria-label="Entity Type"
                    aria-describedby={!otherSelected ? errorId : undefined}
                    interaction="lightbar"
                    state={error && !otherSelected ? "error" : undefined}
                    className="w-full min-w-0"
                >
                    <SelectValue placeholder="Select entity type">
                        {legalEntityTypeLabel(value.selection)}
                    </SelectValue>
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        {LEGAL_ENTITY_TYPE_OPTIONS.map((option) => (
                            <SelectItem key={option.value} value={option.value}>
                                {option.label}
                            </SelectItem>
                        ))}
                        <SelectItem value="other">Other</SelectItem>
                    </SelectGroup>
                </SelectContent>
            </Select>

            {otherSelected ? (
                <Input
                    id={id ? `${id}-other` : undefined}
                    aria-label="Other entity type"
                    aria-describedby={errorId}
                    value={value.other}
                    onChange={(event) =>
                        onChange({ ...value, other: event.target.value })
                    }
                    placeholder="Enter entity type"
                    state={error ? "error" : undefined}
                />
            ) : null}
        </div>
    );
}
